import { Avatar } from 'antd';
import Icon from 'assets/Icons';
import clsx from 'clsx';
import AnyBodyImage from 'components/AnyBodyImage';
import Box from 'components/Box';
import Text from 'components/Text';
import { get } from 'lodash';
import React from 'react';
import styled, { css } from 'styled-components';
import { ic_countdown } from '../icons';
type IComponentProps = {
  selected?: boolean;
  name?: string;
  src?: string;
  onClick?: () => void;
  className?: string;
  anybody?: boolean;
  SelectedIconRender?: () => JSX.Element;
  available?: boolean;
  mode?: 'AVAILABLE' | 'BUSY' | 'OVERTIME',
  billNum?: string | number | null;
  minutes?: number;
};
type AvatarTicketBoxStyledPropsType = {
  selected?: boolean;
  onClick?: () => void;
  margin?: string;
  cashier?: boolean;
};
const StaffBox: React.FC<IComponentProps> = ({
  selected,
  name,
  src,
  onClick,
  anybody,
  className = '',
  SelectedIconRender,
  available = true,
  mode,
  billNum,
  minutes,
}) => {

  if (mode === 'BUSY') return (
    <AvatarTicketBoxStyled onClick={onClick} selected={selected} className={clsx(className, mode)} type='button' disabled={!available}>
      {selected && (SelectedIconRender ? <SelectedIconRender /> : <IconBadgeStyled><Icon type="tick" /></IconBadgeStyled>)}
      <Box position='relative'>
        {anybody ? <AnyBodyImage large /> : <Avatar className="circle-avatar" src={src}>
          {get(name, [0], '')}
        </Avatar>}
        <CircleBox className='busy' />
      </Box>
      <Text textAlign="center" variant="CONTENT_2" color="text_3">
        {name}
      </Text>
      <BoxTicket mode={mode} billNum={billNum} minutes={minutes} />
    </AvatarTicketBoxStyled>
  );

  if (mode === 'OVERTIME') return (
    <AvatarTicketBoxStyled onClick={onClick} selected={selected} className={clsx(className, mode)} type='button' disabled={!available}>
      {selected && (SelectedIconRender ? <SelectedIconRender /> : <IconBadgeStyled><Icon type="tick" /></IconBadgeStyled>)}
      <Box position='relative'>
        {anybody ? <AnyBodyImage large /> : <Avatar className="circle-avatar" src={src}>
          {get(name, [0], '')}
        </Avatar>}
        <CircleBox className='busy' />
      </Box>
      <Text textAlign="center" variant="CONTENT_2" color="text_3">
        {name}
      </Text>
      <BoxTicket mode={mode} billNum={billNum} minutes={minutes} />
    </AvatarTicketBoxStyled>
  );

  if (mode === 'AVAILABLE') return (
    <AvatarTicketBoxStyled onClick={onClick} selected={selected} className={clsx(className, mode)} type='button' disabled={!available}>
      {selected && (SelectedIconRender ? <SelectedIconRender /> : <IconBadgeStyled><Icon type="tick" /></IconBadgeStyled>)}
      <Box position='relative'>
        {anybody ? <AnyBodyImage large /> : <Avatar className="circle-avatar" src={src}>
          {get(name, [0], '')}
        </Avatar>}
        <CircleBox />
      </Box>
      <Text textAlign="center" variant="CONTENT_2" color="text_3">
        {name}
      </Text>
      <Text className='available-text'>
        Available
      </Text>
    </AvatarTicketBoxStyled>
  );

  return (
    <AvatarTicketBoxStyled onClick={onClick} selected={selected} className={className} type='button' disabled={!available} >
      {selected && (SelectedIconRender ? <SelectedIconRender /> : <IconBadgeStyled><Icon type="tick" /></IconBadgeStyled>)}
      <Box position='relative'>
        {anybody ? <AnyBodyImage large /> : <Avatar className="circle-avatar" src={src}>
          {get(name, [0], '')}
        </Avatar>}
        {available ? <CircleBox /> : <CircleBox className='busy' />}
      </Box>
      <Text textAlign="center" variant="CONTENT_2" color="text_3">
        {name}
      </Text>
    </AvatarTicketBoxStyled>
  );
};

export default StaffBox;

const BoxTicket = ({ billNum, minutes = 0, mode }: {
  mode?: IComponentProps['mode'],
  minutes?: IComponentProps['minutes'],
  billNum?: IComponentProps['billNum']
}) => {
  return (
    <BoxTicketContainer className={mode}>
      <div className="bill-number"><span>#{billNum}</span></div>
      <div className="bill-countdown">
        {mode === 'OVERTIME' && <img src={ic_countdown} alt="ic_countdown" style={{ width: '20px', height: '20px' }} />}
        <span>{minutes}m</span>
      </div>
    </BoxTicketContainer>
  );
};
const BoxTicketContainer = styled.div`
display: flex;
padding: 2px 4px;
justify-content: space-between;
flex: 1;
align-items: center;
gap: 8px;
border-radius: 4px;
background: #FFF1F6;
align-self: stretch;
margin: 0 4px;
.bill-number {
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #232F3E;
  span {
    color: #FFF;
    text-align: right;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
}
.bill-countdown {
  display: flex;
  align-items: center;
  span {
    color: #D2464F;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
}
&.BUSY {
  background: #FF7D00;
  .bill-countdown span {
    color: #FFF;
  }
}
`;

const CircleBox = styled.div`
width: 20px;
height: 20px;
border-radius: 20px;
position: absolute;
right: 1.827px;
bottom: 0;
background: #0DA472;
border: 3px solid #fff;

&.busy {
  background: #D2464F;
}
`;

const AvatarTicketBoxStyledCSS = css<AvatarTicketBoxStyledPropsType>`
  border: 1px solid
    ${({ selected }) =>
    selected ? '#6fabb6' : '#ffffff'};
  background: ${({ selected }) =>
    selected ? '#C6E9EF' : '#ffffff'};
  box-shadow: ${({ selected }) =>
    selected
      ? '-1px 1px 4px 0px rgba(0, 0, 0, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25);'
      : 'unset'};
`;

const AvatarTicketBoxStyled = styled.button.withConfig({
  shouldForwardProp: (prop) => !['isBusy', 'boxShadow'].includes(prop),
}) <AvatarTicketBoxStyledPropsType>`
  // margin: ${({ margin }) => margin ? margin : 'auto;'};
  border-radius: 10px;
  display: flex;
  width: 5.5rem;
  min-height: 6.5rem;
  padding: 0.5rem 0.5rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &:active {
    background-color: #C6E9EF;
  }

  ${AvatarTicketBoxStyledCSS}
  
  width: 8.1rem;
  .circle-avatar {
    width: 8rem;
    min-height: 8rem;
    border-radius: 50%;
    font-size: 2.5rem;
    display: flex;
    align-items: center;
  }

  .CONTENT_2 {
    margin-top: 4px;
    font-size: 22px;
  }


  &.BUSY {
    border-radius: 4px;
    border: 2px solid #F4C04B;
    background: #FDF4CE;
    box-shadow: 4px 4px 4px 0 rgba(210, 70, 79, 0.15);
  }

  .available-text {
    color: #0DA472;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const IconBadgeStyled = styled.div`
  position: absolute;
  top: -1rem;
  right: -1rem;
`;
